import { useParams } from "react-router-dom";
import {
  useGetActivityLogDetails,
  useGetActivityLogDetailsRecords,
} from "../../../../../hooks/api/queries/useSettings";

export const useActivityLogDetails = () => {
  const { id } = useParams();
  const { data: activityLogDetails, isLoading: isLoadingActivity } =
    useGetActivityLogDetails({ id });

  const { data, isLoading: isLoadingRecords } = useGetActivityLogDetailsRecords(
    { id },
  );

  return {
    isLoadingActivity,
    isLoadingRecords,
    activityLogDetails,
    activityLogRecords: data?.data || [],
  };
};
